import { UserPermission } from '@globaleris/ui.library'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { InvoiceDetailResponseModel } from '../../api/Argentia/endpoints/invoices/model/invoices'
import ButtonWithPermissions from '../../components/buttonWithPermissions/buttonWithPermissions'
import Page from '../../components/page/page'
import PageHeader from '../../components/page/pageHeader'
import { CustomIframe } from '../../components/shared/customIframe/customIframe'
import { hasPermission } from '../../helpers/permissionsHelper'
import { NonAuthRoutes } from '../../model'
import { Resources } from '../../model/RBAC/constants'
import { getActiveBalanceZone, getActiveCompany, getCustomerDomain } from '../../redux'

export const ManualInvoicePage: React.FC<any> = props => {
  const apiSuffixUrl = 'https://' + getCustomerDomain()
  const [t] = useTranslation(['globalerisLibrary', 'translation', 'invoicesPage'])
  const history = useHistory()

  const canAccessNewEditScreen = hasPermission(Resources.InvoiceCycles, [UserPermission.EDIT])

  const handleGoToNewEditScreen = () => {
    history.push(NonAuthRoutes.InvoicesEdit, {
      invoiceData: {
        id: props.location?.state?.invoiceId,
        code: props.location?.state?.InvoiceCod ?? ''
      } as InvoiceDetailResponseModel
    })
  }

  let activeCompany = getActiveCompany()
  let activeBalanceZone = getActiveBalanceZone()
  const [routeLocal, setRouteLocal] = useState(
    props.location?.state?.isSettlementInvoice
      ? `${apiSuffixUrl}/facturacion/edicion?codFactura=${props.location.state.InvoiceCod}&idEjecucionCiclo=${props.location.state.executionCycleId}`
      : props.location?.state?.InvoiceCod !== undefined
        ? `${apiSuffixUrl}/facturacion/edicion?codFactura=${props.location.state.InvoiceCod}`
        : `${apiSuffixUrl}/facturacion/alta`
  )

  useEffect(() => {
    call()
  }, [activeCompany, activeBalanceZone])

  const call = async () => {
    setRouteLocal(
      `${apiSuffixUrl}/company/index/${activeCompany?.id}?idBalanceZone=${activeBalanceZone?.id}&company=${activeCompany?.description}&balanceZoneDescription=${activeBalanceZone?.description}`
    )

    setTimeout(() => {
      let path = `${apiSuffixUrl}/facturacion/alta`

      if (props.location?.state?.isSettlementInvoice) {
        path = `${apiSuffixUrl}/facturacion/edicion?codFactura=${props.location.state.InvoiceCod}&idEjecucionCiclo=${props.location.state.executionCycleId}`
      } else if (props.location?.state?.InvoiceCod !== undefined) {
        path = `${apiSuffixUrl}/facturacion/edicion?codFactura=${props.location.state.InvoiceCod}`
      }

      setRouteLocal(path)
    }, 1000)
  }

  return (
    <Page>
      <PageHeader title={t('invoicesPage:titleManualInvoice')}>
        <ButtonWithPermissions
          hasPermission={canAccessNewEditScreen}
          size="small"
          variant="contained"
          color="primary"
          onClick={handleGoToNewEditScreen}
        >
          {t('invoicesPage:actions.newEditScreen')}
        </ButtonWithPermissions>
      </PageHeader>
      <CustomIframe
        route={decodeURI(routeLocal)}
        width="100%"
        height="1200"
        allowFullScreen={true}
      />
    </Page>
  )
}
